<template>
  <SceneView msg="---"/>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import SceneView from './components/SceneView.vue';

@Options({
  components: {
    SceneView,
  },
})
export default class App extends Vue {}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  overflow: hidden;
  background: #555;
}  




</style>
